var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "orderdetail-modal",
        width: "100%",
        adaptive: true,
        height: "95%",
        "max-width": 900
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "container modal--container" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-wrap justify-content-between mb-4" },
          [
            _c("h1", [_vm._v(_vm._s(this.orderDetails.restaurant_name))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.$modal.hide("orderdetail-modal")
                  }
                }
              },
              [
                _c(
                  "p",
                  {
                    staticClass: "close-text",
                    attrs: { "aria-hidden": "true" }
                  },
                  [_vm._v("×")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row flex-column flex-md-row mt-2" }, [
          _c("div", { staticClass: "col mb-2 mb-md-0" }, [
            _c("h2", [_vm._v("Office:")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n          " +
                  _vm._s(this.orderDetails && this.orderDetails.location_name) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col mb-2 mb-md-0" }, [
            _c("h2", [_vm._v("Order Date:")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(this.orderDetails && this.orderDetails.order_date))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col mb-2 mb-md-0" }, [
            _c("h2", [_vm._v("Meal Type:")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(this.orderDetails && this.orderDetails.meal_name) + " "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col mb-2 mb-md-0" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  _c("ResOrderStatus", {
                    attrs: { status: this.eta, tzinfo: _vm.timezone }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-custom table-striped__immediate-only table-bordered mt-5"
          },
          [
            _c("thead", [
              _c("tr", [
                _c("th", { attrs: { scope: "col" } }, [_vm._v("Item")]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col", width: "75" } }, [
                  _vm._v("Quantity")
                ]),
                _vm._v(" "),
                _c("th", { attrs: { scope: "col", width: "105" } }, [
                  _vm._v("Food Total")
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.orderItems, function(item) {
                  return _c("tr", { key: item.id }, [
                    _c("td", { attrs: { colspan: "3" } }, [
                      _c("table", { staticClass: "w-100 no-border-table" }, [
                        _c("tr", [
                          _c("td", [
                            _c("div", { staticClass: "col-12 col-md-6" }, [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.attributes.menu_item
                                      .display_name_with_html
                                  )
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { width: "65" }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(item.attributes.quantity) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { width: "105" }
                            },
                            [
                              _c("div", [
                                _c("p", [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        parseFloat(
                                          item.attributes.price
                                        ).toFixed(2)
                                      )
                                  )
                                ])
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "table",
                              { staticClass: "w-100" },
                              _vm._l(
                                item.attributes.order_item_options,
                                function(option) {
                                  return _c(
                                    "tr",
                                    { key: option.id, staticClass: "mt-2" },
                                    [
                                      _c("td", { staticClass: "border-0" }, [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-wrap" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-md-3 caption"
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "caption",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      option.attributes
                                                        .option_group_display_name_with_html
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-md-3 caption"
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "caption",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      option.attributes
                                                        .option_display_name_with_html
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", {
                                        staticClass: "border-0",
                                        attrs: { width: "65" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-center border-0",
                                          attrs: { width: "105" }
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "span",
                                              { staticClass: "caption" },
                                              [
                                                _vm._v(
                                                  "\n                            $\n                            " +
                                                    _vm._s(
                                                      parseFloat(
                                                        option.attributes.price
                                                      ).toFixed(2)
                                                    ) +
                                                    "\n                          "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "no-border-table" }, [
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              item.attributes &&
                              item.attributes.special_instructions &&
                              item.attributes.special_instructions != ""
                                ? _c("p", { staticClass: "order-id mt-2" }, [
                                    _vm._v(
                                      "\n                      Instructions:\n                      " +
                                        _vm._s(
                                          item.attributes.special_instructions
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                }),
                _vm._v(" "),
                (_vm.orderDetails.permanent_instructions &&
                  _vm.orderDetails.permanent_instructions != "") ||
                _vm.orderDetails.cutlery
                  ? _c("tr", [
                      _c("td", { attrs: { colspan: "3" } }, [
                        _c("div", { staticClass: "col-md-6 col-lg-12" }, [
                          _vm.orderDetails.permanent_instructions &&
                          _vm.orderDetails.permanent_instructions != ""
                            ? _c("p", { staticClass: "order-id mt-2" }, [
                                _vm._v(
                                  "\n                Permanent Instructions:\n                " +
                                    _vm._s(
                                      _vm.orderDetails.permanent_instructions
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orderDetails.cutlery
                            ? _c("p", { staticClass: "order-id mt-2" }, [
                                _vm._v(
                                  "\n                Cutlery:\n                " +
                                    _vm._s(
                                      _vm.orderDetails.cutlery ? "Yes" : "No"
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row ml-0 ml-md-3 justify-content-between mt-4" },
          [
            _c("div", { staticClass: "col-5" }, [
              _c("p", [
                _vm._v("\n          Food Total:\n          "),
                _c("strong", [
                  _vm._v(
                    "\n            $ " +
                      _vm._s(
                        parseFloat(this.orderDetails.subtotal).toFixed(2)
                      ) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n          " + _vm._s(this.taxCode) + ":\n          "),
                _c("strong", [
                  _vm._v(
                    "$" +
                      _vm._s(parseFloat(this.orderDetails.hst).toFixed(2)) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              this.orderDetails.tip_user_select
                ? _c("p", [
                    _vm._v("\n          Tip:\n          "),
                    _c("strong", [
                      _vm._v(
                        "\n            $" +
                          _vm._s(parseFloat(this.orderDetails.tip).toFixed(2))
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n          Grand Total:\n          "),
                _c("strong", [
                  _vm._v(
                    "\n            $" +
                      _vm._s(
                        parseFloat(
                          this.orderDetails.grand_total_for_user
                        ).toFixed(2)
                      ) +
                      "\n          "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-5" }, [
              _c("p", [
                _vm._v("\n          Paid By User:\n          "),
                _c("strong", [
                  _vm._v(
                    "\n            $" +
                      _vm._s(
                        Number(
                          this.orderDetails.amount_paid_by_employee
                        ).toFixed(2)
                      ) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n          Subsidized By Office:\n          "),
                _c("strong", [
                  _vm._v(
                    "\n            $" +
                      _vm._s(
                        Number(
                          this.orderDetails.amount_paid_by_employer
                        ).toFixed(2) >
                          parseFloat(
                            this.orderDetails.grand_total_for_user
                          ).toFixed(2)
                          ? parseFloat(
                              this.orderDetails.grand_total_for_user
                            ).toFixed(2)
                          : Number(
                              this.orderDetails.amount_paid_by_employer
                            ).toFixed(2)
                      ) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
                (this.orderDetails &&
                  this.orderDetails.status &&
                  this.orderDetails.status === "COMPLETED") ||
                this.orderDetails.status === "ORDER COMPLETED"
                  ? _c(
                      "button",
                      {
                        staticClass: "float-right modal__btn mr-2 mb-2 mb-md-0",
                        on: {
                          click: function($event) {
                            return _vm.openForm()
                          }
                        }
                      },
                      [_vm._v("\n            Leave Feedback\n          ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "modal__btn",
                    on: {
                      click: function($event) {
                        return _vm.$modal.hide("orderdetail-modal")
                      }
                    }
                  },
                  [_vm._v("\n            Close\n          ")]
                )
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08bda1de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08bda1de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetailModal.vue
// module id = null
// module chunks = 